import { StorageService } from './../../../../services/storage/storage.service';
import { DetailsService } from './../../details.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { RequestSubmitRbDailog } from '../request-submit-rb-dailog/request-submit-rb-dailog.component';
import { SharedService } from './../../../../services/shared/shared.service';
import { TARGETTYPE } from '../../../../services/search/search.service';
import { RoutingService } from '../../../../services/routing/routing.service';
import { DIALOG_STYLE } from '../../../../../assets/css/ag/styles';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RegisterComponent implements OnInit {
  registerRB: UntypedFormGroup;
  registerZN: UntypedFormGroup;
  loginZN: UntypedFormGroup;
  targetType: any;
  showRBForm: any = false;
  showZNForm: any = false;
  showRegisterInfo = true;
  showLoginInfo = false;

  libraryLabel: any = 'Library Card Number';
  userNameLabel: any = 'User Name';
  passwordLabel: any = 'Password';
  firstNameLabel: any = 'First Name';
  lastNameLabel: any = 'Last Name';
  emailLabel: any = 'Email Address';
  zipLabel: any = 'Zip Code';

  TARGETTYPE = TARGETTYPE;

  private _formType = 'register';
  private _agcontrolid: any;
  private _shard: any;
  private _patronSubmitDetails: any;
  private _userInfo: any;
  private _userName: string;
  private _errorMessage = 'unable to login.';
  private _fullRecord: any;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _dialog: MatDialog,
    private _fb: UntypedFormBuilder,
    private _detailsService: DetailsService,
    private _router: Router,
    private _sharedService: SharedService,
    private _storageService: StorageService,
    private _routingService: RoutingService,
  ) {
    this.showRBForm = false;
    this.showZNForm = false;
    this.showRegisterInfo = true;
    this.showLoginInfo = false;
  }

  ngOnInit() {
    this._activatedRoute.queryParams.subscribe((params: Params) => {
      this.targetType = params['type'] ? params['type'].toUpperCase() : null;
      this._agcontrolid = params['agctrlid'];
      this._shard = params['shard'];
      this._formType = params['formType'] ? params['formType'].toLowerCase() : 'register';
      this._detailsService
        .getFullRecordByShard(this._buildRecordDetails())
        .subscribe((fullRecord) => {
          this._fullRecord = fullRecord;
          this._userInfo = this._storageService.getUserData();
          this._userName = this._userInfo.userName;
          if (this.targetType === TARGETTYPE.RB) {
            this._intializeRBFormData();
          } else if (this.targetType === TARGETTYPE.ZN) {
            if (this._formType == 'register') {
              this._intializeZNFormData();
            } else if (this._formType == 'login') {
              this._intializeZNLoginFormData();
            }
          }
        });
    });
  }

  async loginZNSubmit() {
    try {
      const status = await this._loginZnAsync();
      if (status) {
        this._fullRecordRoute();
      } else {
        this._sharedService.openSnackBar(this._errorMessage, 'ok');
      }
    } catch (error) {
      console.error(`register.component.ts:- loginZNSubmit => ${error.message}`);
    }
  }

  private async _loginZnAsync() {
    const response = await this._detailsService.loginUserZNAsync(
      this._fullRecord.session.agServiceBaseUrl,
      this._buildZNloginData(),
    );
    if (response && response != null && response.Data && response.StatusCode == 0) {
      if (response.Data.Success) {
        return true;
      } else if (!response.Data.Success) {
        this._errorMessage = response.Data.ErrorMessage
          ? response.Data.ErrorMessage
          : this._errorMessage;
        if (this._errorMessage.toLowerCase() == 'not found') {
          this._errorMessage = 'user ' + this._errorMessage + '. unable to authenticate.';
        }
      }
    } else if (response.Data.StatusMessage) {
      this._errorMessage = response.Data.StatusMessage
        ? response.Data.StatusMessage
        : this._errorMessage;
    }

    return false;
  }

  registerZNSubmit(): void {
    this._detailsService
      .registerUserZN(this._fullRecord.session.agServiceBaseUrl, this._buildZNregisterData())
      .subscribe((response) => {
        const status = response.Data.Success;
        const message = response.Data.ErrorMessage;
        if (status == true) {
          this._sharedService.openSnackBar('Zinio Patron profile is created', 'ok');
          this._fullRecordRoute();
        } else if (status == false) {
          this._sharedService.openSnackBar(message, 'ok');
        }
      });
  }

  // --------------------- registratin submit form -------------------

  registerRBSubmit(): void {
    // ------------------------ build submit body and call the serivce -------------------
    this._detailsService
      .registerUserRB(this._fullRecord.session.agServiceBaseUrl, this._buildRBregisterData())
      .subscribe((response) => {
        const status = response.Data.Status.Success;
        const message = response.Data.Status.ErrorMessage;
        if (status == true) {
          this._sharedService.openSnackBar(message, 'ok');
          this._patronSubmitDetails = response.Data.patron;
          // put this in a pop up
          this.openRegsiterSubmitDialog(this._patronSubmitDetails, 'success');
        } else if (status == false) {
          this.openRegsiterSubmitDialog(message, 'fail');
        }
      });
  }

  openRegsiterSubmitDialog(data, type): void {
    const dialogRef = this._dialog.open(RequestSubmitRbDailog, {
      panelClass: DIALOG_STYLE.MD,
      disableClose: true,
      data: {
        details: data,
        type: type,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'ok') {
        // go to full record
        this._fullRecordRoute();
      } else if (result == 'close') {
        // do nothing
      }
    });
  }

  private _intializeZNLoginFormData(): void {
    this.loginZN = this._fb.group(
      {
        email: [
          '',
          [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$')],
        ],
        password: ['', [Validators.required, Validators.minLength(3)]],
        firstname: [''],
        lastname: [''],
      },
      { updateOn: 'blur' },
    );
    this._showZnForm();
    this._showLoginFormType();
  }

  private _intializeZNFormData(): void {
    // ------------------ reactive form for ZN registration ---------------
    this.registerZN = this._fb.group(
      {
        // Reactive Form for improved event handling.
        //library: ['', Validators.required],
        email: [
          '',
          [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$')],
        ],
        password: ['', [Validators.required, Validators.minLength(3)]],
        firstname: ['', Validators.required],
        lastname: ['', Validators.required],
      },
      { updateOn: 'blur' },
    ); // https://netbasal.com/boosting-performance-with-the-new-updateon-option-in-angular-v5-18857279ace2
    this._showZnForm();
    this._showRegisterFormType();
  }

  private _intializeRBFormData(): void {
    // ------------------ reactive form for RB registration ---------------
    this.registerRB = this._fb.group(
      {
        // Reactive Form for improved event handling.
        //library: ['', Validators.required],
        libname: ['', Validators.required],
        user: ['', Validators.required],
        password: ['', [Validators.required, Validators.minLength(3)]],
        firstname: ['', Validators.required],
        lastname: ['', Validators.required],
        email: [
          '',
          [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$')],
        ],
        zip: ['', Validators.required],
      },
      { updateOn: 'blur' },
    ); // https://netbasal.com/boosting-performance-with-the-new-updateon-option-in-angular-v5-18857279ace2
    this.registerRB.valueChanges.subscribe((value) => {});
    this.registerRB.patchValue({
      libname: this._userName,
    });
    this.registerRB.controls['libname'].disable();
    // this.registerRB.reset(this.registerRB.value);
    this._showRBForm();
    this._showRegisterFormType();
  }

  private _buildZNloginData(): object {
    const result = {
      CustomerId: this._fullRecord.session.customerId,
      UserId: this._fullRecord.session.userId,
      LibraryProfileKey: this._fullRecord.session.libraryProfileKey,
      Options: {
        ZinioUrl: this._fullRecord.zinioSearchSettings.url,
        ZinioLibraryId: this._fullRecord.zinioSearchSettings.libraryId,
        ZinioToken: this._fullRecord.zinioSearchSettings.token,
      },
      Patron: {
        Email: this.loginZN.value.email,
        Password: this.loginZN.value.password,
        FirstName: '',
        LastName: '',
      },
    };
    return result;
  }

  private _buildZNregisterData(): object {
    const result = {
      UserId: this._fullRecord.session.userId,
      LibrayProfileKey: this._fullRecord.session.libraryProfileKey,
      Patron: {
        Email: this.registerZN.value.email,
        Password: this.registerZN.value.password,
        FirstName: this.registerZN.value.firstname,
        LastName: this.registerZN.value.lastname,
      },
      CustomerId: this._fullRecord.session.customerId,
      Options: {
        ZinioUrl: this._fullRecord.zinioSearchSettings.url,
        ZinioLibraryId: this._fullRecord.zinioSearchSettings.libraryId,
        ZinioToken: this._fullRecord.zinioSearchSettings.token,
      },
    };
    return result;
  }

  private _buildRBregisterData(): object {
    let rbSet: number;
    if (this._fullRecord.rbSearchSettings.enable) {
      rbSet === 1;
    } else {
      rbSet === 0;
    }
    const result = {
      UserId: this._fullRecord.session.userId,
      LibraryProfileKey: this._fullRecord.session.libraryProfileKey,
      Data: {
        LibraryCardNumber: this._userName,
        UserName: this.registerRB.value.user,
        Password: this.registerRB.value.password,
        FirstName: this.registerRB.value.firstname,
        LastName: this.registerRB.value.lastname,
        Email: this.registerRB.value.email,
        Zip: this.registerRB.value.zip,
      },
      SessionId: this._fullRecord.session.id,
      CustomerId: this._fullRecord.session.customerId,
      CustomerServer: this._fullRecord.session.customerServer,
      Options: {
        RecordedBooksEnabled: rbSet,
        RecordedBooksUrl: this._fullRecord.rbSearchSettings.url,
        RecordedBooksLibraryId: this._fullRecord.rbSearchSettings.libraryId,
        RecordedBooksToken: this._fullRecord.rbSearchSettings.token,
      },
    };
    return result;
  }

  private _buildRecordDetails(): object {
    const result = {
      source: this._shard,
      agcontrolid: this._agcontrolid,
      hldStartRecord: 1,
      hldNumOfRecords: 10,
    };
    return result;
  }

  private _showLoginFormType(): void {
    this.showLoginInfo = true;
    this.showRegisterInfo = false;
  }

  private _showRegisterFormType(): void {
    this.showLoginInfo = false;
    this.showRegisterInfo = true;
  }

  private _showZnForm(): void {
    this.showRBForm = false;
    this.showZNForm = true;
  }

  private _showRBForm(): void {
    this.showRBForm = true;
    this.showZNForm = false;
  }

  // ------------------------- registration on success function ----------------------------
  private _fullRecordRoute(): void {
    // --------------- route the use to full record they came from -----------------------
    this._router.navigate(['/details'], {
      queryParams: { agctrlid: this._agcontrolid, shard: this._shard },
    });
  }

  go2PrevRoute(): void {
    this._routingService.goToPreviousUrl();
  }
}
